import React, { useEffect, useState } from 'react';
import Header from "../../../../components/Headers/BasicHeader";
import '../Index.css'
import Paginations from '../../../../components/Pagination/BasicPagination';
import { useNavigate } from "react-router-dom";
import { setDataOnGrid, applySearch } from '../../../../utils/views/pages/Dynamics'

import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    Table,
    Form,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup,
    Button,
    Spinner
} from "reactstrap";
import { getStudents, studentBoundList, deleteStudent, bindStudent, getImage } from "../../../../network/ApiAxios";
import ConfirmModal from 'components/Modals/ConfirmModal';
import BasicModal from 'components/Modals/BasicModal'
import secureLocalStorage from "react-secure-storage";

const Students = () => {

    const [students, setStudents] = useState([]);
    const [studentsBackup, setStudentsBackup] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [showBasicModal, setShowBasicModal] = useState(false)
    const [modalMessage, setModalMessage] = useState("")
    const [modalBasicMessage, setModalBasicMessage] = useState("")
    const [modalTitle, setModalTitle] = useState()
    const [modalBasicTitle, setModalBasicTitle] = useState()
    const [modalResult, setModalResult] = useState(false)
    const [modalOperation, setModalOperation] = useState()
    const [reloadData, setReloadData] = useState(false)
    const [deletedId, setDeletedId] = useState()
    const [bindingId, setBindingId] = useState()
    const [bindingStudent, setBindingStudent] = useState(null)
    const [itemsPerPage, setItemsPerPage] = useState(process.env.REACT_APP_PAGE_ITEMS)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchKey, setSearchKey] = useState('')
    const [foundRegisters, setFoundRegisters] = useState()
    const [loadingId, setLoadingId] = useState('')
    const [isLoading, setisLoading] = useState(false)
    const [appImage, setAppImage] = useState(null)

    const [sortField, setSortField] = useState('')
    const [sortDirection, setSortDirection] = useState('asc')

    const user = JSON.parse(secureLocalStorage.getItem("user"));
    const app = JSON.parse(secureLocalStorage.getItem("app"));
    const navigate = useNavigate();
    const searchFields = ['name', 'institution.name']
    const [searchAction, setSearchAction] = useState(false)

    /**
     * Carrega a imagem do app
     */
    useEffect(() => {
        const loadAppImage = async () => {
            if (app?.image) {
                try {
                    const response = await getImage(app.image);
                    const { data } = response;
                    setAppImage(data);
                } catch (error) {
                    console.error("Error loading app image:", error);
                }
            }
        };
        loadAppImage();
    }, []);

    /**
     * Carregamento dos dados principais para alimentar o grid 
     * Alimenta os objetos que permitirão realizar buscas e filtragens
     * dinamicamente
     */
    useEffect(() => {
        const runAsync = async () => {
            setisLoading(true);

            let params = {
                filter: { account: user.account, active: true },
                constraint: { app: app._id, installation: { active: true } }
            }

            const response = await studentBoundList(params);
            const { data } = response;

            if (data.success) {
                setFoundRegisters(data.students?.length)

                const sortedData = applySorting(data.students);
                setDataOnGrid(sortedData, setStudents, currentPage, itemsPerPage);
                setStudentsBackup(data.students);
                setReloadData(false);
                setLoadingId('');
                setisLoading(false);

            } else {
                handleErrors(data.msg)
            }
        }
        runAsync();
    }, [reloadData]);

    /**
     * Trata ações realizadas nesta pagina, como a deleção de objetos
     * e a vinculação de estudantes com licenças ativas da conta para 
     * uso de aplicativos
     */
    useEffect(() => {
        if (modalResult && modalOperation == 'delete') {
            const runAsync = async () => {

                setLoadingId(deletedId);
                const response = await deleteStudent(deletedId);
                const { data } = response;

                if (data.success) {
                    setReloadData(true);
                    setModalResult(false);
                    setDeletedId('');
                } else {
                    handleErrors(data.msg)
                }
            }
            runAsync();
        } else if (modalResult && modalOperation == 'bind') {

            const updateStudentBound = (dataSource) => {
                dataSource?.forEach(student => {
                    if (student._id == bindingId)
                        student.isBound = true
                    return student
                });
            }

            const runAsync = async () => {

                const student = {
                    _id: bindingId,
                    account: user.account,
                    app: app._id
                }

                const response = await bindStudent(student);
                const { data } = response;

                if (data.success) {
                    //atualizamos os dados do grid sem realizar nova consulta no banco
                    updateStudentBound(students)
                    updateStudentBound(studentsBackup)
                    setModalResult(false);
                    setBindingId('')
                } else {
                    handleErrors(data.msg)
                }
            }
            runAsync();
        }
    }, [modalResult])

    /**
     * Gatilho que captura situações onde devemos realizar busca de dados de acordo com 
     * filtro e reordenar os dados para mostrar no grid
     */
    useEffect(() => {
        if(!searchAction){
            applySearch(searchKey, searchFields, setStudents, studentsBackup, setFoundRegisters, currentPage, itemsPerPage, true);
            const sortedData = applySorting(studentsBackup);
            setDataOnGrid(sortedData, setStudents, currentPage, itemsPerPage);
        } else {
            setSearchAction(false)
        }

    }, [sortField, sortDirection, searchKey, currentPage, itemsPerPage])

    const sortData = (data, field, direction) => {
        if (!field) return data;

        const getNestedValue = (obj, path) => {
            return path.split('.').reduce((acc, part) => acc && acc[part], obj);
        }

        return [...data].sort((a, b) => {
            let aValue = getNestedValue(a, field) || '';
            let bValue = getNestedValue(b, field) || '';
            if (typeof aValue === 'string') aValue = aValue.toLowerCase();
            if (typeof bValue === 'string') bValue = bValue.toLowerCase();

            if (direction === 'asc') {
                //Para ordem crescrente
                return aValue > bValue ? 1 : -1;
            } else {
                //Para ordem decrescente
                return aValue < bValue ? 1 : -1;
            }
        })

    }

    const applySorting = (data) => {
        if (!sortField) return data;
        return sortData(data, sortField, sortDirection);
    }

    let handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
        setCurrentPage(1);
    }

    let handleErrors = (message) => {
        setModalBasicTitle("Operation Error")
        setModalBasicMessage(message)
        setShowBasicModal(true)
    }

    let handleDelete = (id) => {
        setModalOperation("delete")
        setModalTitle("Student Deletion")
        setModalMessage("Are you sure you want to delete this student?")
        setShowModal(true)
        setDeletedId(id)
    }

    let handleSearch = (e) => {
        setSearchAction(true)
        setSearchKey(e.target.value)
        applySearch(e.target.value, searchFields, setStudents, studentsBackup, setFoundRegisters, currentPage, itemsPerPage, true);
    }

    let handleBind = (id) => {
        // Encontra o estudante que está sendo vinculado
        const student = studentsBackup.find(s => s._id === id);
        console.log(student)
        if (student) {
            setBindingStudent({
                name: student.name,
                institution: student.institution?.name,
            });
        }
        
        setModalOperation("bind");
        setModalTitle("Link Student to License");
        setModalMessage(`You are about to bind this student to an application license.`);
        setShowModal(true);
        setBindingId(id);
    }

    return (
        <>
            <Header></Header>

            <Container>
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0 pb-3 pt-3 pt-md-3">

                                <Row id="headerOptions" className=''>

                                    <Col lg="8" md="8">
                                        <Form className="navbar-search-light form-inline mr-3 d-none d-md-flex  w-100   ">
                                            <FormGroup className="mb-0 w-100 ">
                                                <InputGroup id="search-input" className="input-group-alternative w-100 ">

                                                    <InputGroupAddon addonType="prepend" className='w-100'>
                                                        <InputGroupText >
                                                            <i className="fas fa-search" />
                                                        </InputGroupText>
                                                        <Input value={searchKey} onChange={handleSearch} className='w-100' placeholder="Search" type="text" />
                                                    </InputGroupAddon>

                                                </InputGroup>
                                            </FormGroup>
                                        </Form>
                                    </Col>
                                    <Col id='addButton' lg="4" md="4">
                                        <Button onClick={() => navigate('/admin/student/create')}
                                            className="btn-icon btn-3" color="primary" type="button">

                                            <span className="btn-inner--text">Create a student</span>

                                            <span className="btn-inner--icon">
                                                <i className="ni ni-fat-add" />
                                            </span>

                                        </Button>
                                    </Col>

                                </Row>
                            </CardHeader>

                            {isLoading && !loadingId ? (
                                <div className="text-center p-5">
                                    <Spinner size="lg" />
                                </div>

                            ) : (


                                <Table className="align-items-center table-flush" responsive>
                                    <thead >
                                        <tr>
                                            <th scope="col"
                                                onClick={() => handleSort('name')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'name' ? 'table-header-sorted' : ''}
                                            >
                                                Full Name

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />


                                            </th>
                                            <th scope="col"
                                                onClick={() => handleSort('institution.name')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'institution.name' ? 'table-header-sorted' : ''}
                                            >
                                                Institution

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />


                                            </th>
                                            <th scope="col"
                                                onClick={() => handleSort('expirationDate')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'expirationDate' ? 'table-header-sorted' : ''}
                                            >
                                                Expiration Date

                                                <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />


                                            </th>
                                            <th scope="col" className='text-right'>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {students.map(student => (
                                            <tr key={student._id}>
                                                <td scope="row">  {student.name} </td>
                                                <td scope="row">  {student.institution?.name} </td>
                                                <td scope="row">  {student.expirationDate} </td>
                                                <td className='text-right'>
                                                    {function () {
                                                        if (!student.isBound)
                                                            return (

                                                                <Button className="btn-icon action" color="info" type="button"
                                                                    onClick={() => handleBind(student._id)}
                                                                    disabled={loadingId === student._id}

                                                                >

                                                                    <span className="btn-inner--icon">
                                                                        <img
                                                                            id="bind-button"
                                                                            alt="bind"
                                                                            src={require("assets/img/icons/common/bind.svg").default}
                                                                        />
                                                                    </span>


                                                                </Button>
                                                            )
                                                    }()
                                                    }

                                                    <Button className="btn-icon action" color="success" type="button"
                                                        onClick={() => navigate('/admin/student/view/' + student._id)}
                                                        disabled={loadingId === student._id}

                                                    >

                                                        <span className="btn-inner--icon">
                                                            <img
                                                                id="view-button"
                                                                alt="view"
                                                                src={require("assets/img/icons/common/eye-button.svg").default}
                                                            />
                                                        </span>

                                                    </Button>

                                                    <Button className="btn-icon action" color="primary" type="button"
                                                        onClick={() => navigate('/admin/student/edit/' + student._id)}
                                                        disabled={loadingId === student._id}
                                                    >

                                                        <span className="btn-inner--icon">
                                                            <img

                                                                alt="edit"
                                                                src={require("assets/img/icons/common/edit-button.svg").default}
                                                            />
                                                        </span>

                                                    </Button>
                                                    <Button className="btn-icon action" color="warning" type="button"
                                                        onClick={() => handleDelete(student._id)}
                                                        disabled={loadingId === student._id}
                                                    >

                                                        {loadingId === student._id ? (
                                                            <Spinner size="sm" className="me-2 mx-1" />

                                                        ) : (
                                                            <>
                                                                <span className="btn-inner--icon">
                                                                    <img
                                                                        id="delete-button"
                                                                        alt="delete"
                                                                        src={require("assets/img/icons/common/delete-button.svg").default}
                                                                    />
                                                                </span>
                                                            </>
                                                        )}

                                                    </Button>

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>


                            )}
                        </Card>
                    </div>
                </Row>

                <Row className='pt-md-3'>
                    <Col>
                        <span className="h5 itens-quantity">
                            {studentsBackup?.length} students
                        </span>
                    </Col>
                    <Col>
                        <Paginations
                            itemsPerPage={itemsPerPage}
                            totalItems={foundRegisters}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                        />

                    </Col>
                </Row>

            </Container>

            <ConfirmModal
                title={modalTitle}
                message={modalMessage}
                showModal={showModal}
                setShowModal={setShowModal}
                setModalResult={setModalResult}
                modalOperation={modalOperation}
                bindingData={modalOperation === 'bind' ? bindingStudent : null}
                appData={modalOperation === 'bind' ? {
                    name: app.name,
                    version: app.version,
                    image: appImage
                } : null}
            />
            <BasicModal
                title={modalBasicTitle}
                message={modalBasicMessage}
                showModal={showBasicModal}
                setShowModal={setShowBasicModal} />
        </>
    );
}

export default Students;